const CONTACT_EMAIL = 'contact@estimate.events';
const LANDING_URL =
  (import.meta.env.VITE_LANDING_URL as string | undefined) ?? '';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">estimate.events</div>
        <div className="footer-links">
          <a
            href={`${LANDING_URL}/#about`}
            target="_blank"
            rel="noopener noreferrer"
          >
            About
          </a>
          <a
            href={`${LANDING_URL}/privacy`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </a>
          <a
            href={`${LANDING_URL}/terms`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </a>
        </div>
        <div className="footer-contact">
          <span className="footer-contact-label">Contact:</span>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </div>
        <div className="footer-meta">© {year}</div>
      </div>
    </footer>
  );
}
